import type { TeamsManagementTabTrackingName } from "app/pages/sales-intelligence/modules/teams/services/tracking/factory";

export const TEAMS_MANAGEMENT_TAB = {
    teams: "teams",
    assignedUsers: "assignedUsers",
    unassignedUsers: "unassignedUsers",
} as const;

export const TEAMS_MANAGEMENT_TAB_OPTIONS = [
    TEAMS_MANAGEMENT_TAB.teams,
    TEAMS_MANAGEMENT_TAB.assignedUsers,
    TEAMS_MANAGEMENT_TAB.unassignedUsers,
] as const;

export type TeamsManagementTab = (typeof TEAMS_MANAGEMENT_TAB_OPTIONS)[number];

export const TEAMS_MANAGEMENT_TAB_LABEL_MAP: Record<TeamsManagementTab, string> = {
    [TEAMS_MANAGEMENT_TAB.teams]: "si.management.teams.tab.teams",
    [TEAMS_MANAGEMENT_TAB.assignedUsers]: "si.management.teams.tab.assigned_users",
    [TEAMS_MANAGEMENT_TAB.unassignedUsers]: "si.management.teams.tab.unassigned_users",
};

export const TEAMS_MANAGEMENT_TAB_AUTOMATION_MAP: Record<TeamsManagementTab, string> = {
    [TEAMS_MANAGEMENT_TAB.teams]: "teams-management-tab-teams",
    [TEAMS_MANAGEMENT_TAB.assignedUsers]: "teams-management-tab-assigned-users",
    [TEAMS_MANAGEMENT_TAB.unassignedUsers]: "teams-management-tab-unassigned-users",
};

export const TEAMS_MANAGEMENT_TAB_TRACKING_MAP: Record<TeamsManagementTab, TeamsManagementTabTrackingName> = {
    [TEAMS_MANAGEMENT_TAB.teams]: "teams",
    [TEAMS_MANAGEMENT_TAB.assignedUsers]: "assigned users",
    [TEAMS_MANAGEMENT_TAB.unassignedUsers]: "unassigned users",
};
